import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.upgrade-license.tier', {
        url: '/tier',
        component: 'upgradeLicenseTier',
        resolve: {},
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/tier/upgrade-license-tier.state.js